import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CampaignSummaryFragment,
  ReviewMinimalFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import { ReviewIcon } from "../../icons";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type ReviewDocumentDeletedActivity = ActivityFragment & {
  recipient: CampaignSummaryFragment;
  trackable: ReviewMinimalFragment;
};

export function isReviewDocumentDeletedActivity(
  q: ActivityFragment
): q is ReviewDocumentDeletedActivity {
  return q.key === "review.document_deleted";
}

interface ReviewDocumentDeletedActivityProps {
  activity: ReviewDocumentDeletedActivity;
}

export const ReviewDocumentDeletedActivity: React.FC<ReviewDocumentDeletedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="reviewDocumentDeletedActivity"
        visual={<ReviewIcon className="w-10 h-10 text-accent-500" />}
      >
        <Text fontSize="sm">
          {t("activity.labels.reviewDocumentDeleted", {
            review: (
              <Link to={`/reviews/${activity.trackable.id}`}>
                {t("activity.objects.review")}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
